import { Text, ToggleGroup } from '@components'
import { BookHeart, Sparkles } from 'lucide-solid'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { useSetups } from './state'

export const Filter = (props: ToggleGroup.RootProps) => {
	const { mode, setMode } = useService(useSetups)()

	return (
		<ToggleGroup.Root
			value={[mode()]}
			onValueChange={({ value }) => setMode(value[0] as any)}
			size="sm"
			{...props}
		>
			<ToggleGroup.Item
				class={css({
					height: 6,
          p: 1,
					pointerEvents: mode() === 'latest' ? 'none' : 'all',
				})}
				value="latest"
			>
        <Text>All</Text>
				{/* <Sparkles /> */}
			</ToggleGroup.Item>
			<ToggleGroup.Item
				class={css({
          height: 6,
          p: 1,
					pointerEvents: mode() === 'taken' ? 'none' : 'all',
				})}
				value="taken"
        >
        <Text>Subscribed</Text>
				{/* <BookHeart /> */}
			</ToggleGroup.Item>
		</ToggleGroup.Root>
	)
}
